'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var Notification = require('utils/notification');
var AbstractTableView = require('components/common/views/abstract_table_view');
var DeviceStatsTemplate = require('components/devices/templates/groups/group_device_stats');
var GroupFieldSettingsTemplate = require('components/devices/templates/groups/group_settings_fields');
var GroupPermSettingsTemplate = require('components/devices/templates/groups/group_settings_permissions');
var GroupUsersTemplate = require('components/devices/templates/groups/group_users');
var Utils = require('components/common/utils');

module.exports = OOP.extend(
    AbstractTableView,
    {
        initialize: function (options) {
            this.controller = options.controller;
            this.collection = options.collection;
            this.showUserGroups = options.showUserGroups;

            AbstractTableView.prototype.initialize.apply(this, [this.getTableConfiguration()]);
        },

        ui: OOP.inheritedObj('ui', {
            delete: '.js-tab-btn-delete',
        }),

        events: function () {
            return _.extend({}, AbstractTableView.prototype.events, {
                'click .js-tab-btn-add': 'add',
                'click tr td a.js-name': 'onEditRow',
                'click .js-tab-btn-invite': 'invite',
                'click a.js-delete-group-user': 'deleteGroupUser',
            });
        },

        deleteGroupUser: function (e) {
            var self = this;
            e.preventDefault();

            Utils.showConfirmationDialog({
                title: i18n.TR('Einträge löschen'),
                hint: i18n.TR('Wollen Sie den Benutzer wirklich aus der Gruppe entfernen?'),
                action_label: i18n.TR('Löschen'),

                action_cb: function () {
                    var groupID = $(e.currentTarget).attr('data-group');
                    var userID = $(e.currentTarget).attr('data-user');
                    $.when(App.request('group:delete:user', groupID, userID)).done(function (err) {
                        // refresh
                        if (err) {
                            Notification.show(
                                'error',
                                i18n.TR('Fehler'),
                                i18n.TR('Eintrag konnte nicht gelöscht werden.')
                            );
                            return;
                        }
                        var listReq = App.request(
                            'groups:list',
                            self.showUserGroups ? Consts.GroupReqMode.User : Consts.GroupReqMode.Standard
                        );
                        $.when(listReq).done(function (data) {
                            self.collection = data;
                            self.render();
                        });
                    });
                },
            });
        },

        invite: function (e) {
            e.preventDefault();
            this.controller.inviteToGroups(
                _.map(_.values(this.collection.selected), function (x) {
                    return x.toJSON();
                })
            );
        },

        onEditRow: function (e) {
            if (!AppState.hasCompanyUserPermission() && this.showUserGroups) return;

            var id = parseInt($(e.currentTarget).attr('data-idx'));
            var model = this.collection.get(id);
            if (this.showUserGroups) this.controller.showUserGroup(model);
            else this.controller.showGroup(model);
        },

        getTableConfiguration: function () {
            var buttons = [];
            if (this.showUserGroups) {
                buttons.push({ ButtonText: i18n.TR('Freigeben'), ButtonID: 'invite', ButtonIcon: 'md md-group' });
            }
            buttons.push({ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' });

            var customButtons = [];
            if (!this.showUserGroups || AppState.hasCompanyUserPermission())
                customButtons.push({
                    ButtonIcon: 'fa fa-plus',
                    ButtonID: 'add',
                });

            var columns = [
                {
                    id: '#_name',
                    name: 'Name', // i18n.TR('Name')
                    alwaysVisible: true,
                    displayMethod: 'groupLink',
                },
                {
                    id: '#_filter',
                    name: 'Filter', // i18n.TR('Filter')
                    displayMethod: 'filter',
                },
            ];

            if (this.showUserGroups) {
                columns.push({
                    id: '#_users',
                    name: 'Benutzer', // i18n.TR('Benutzer')
                    displayMethod: 'users',
                });
                columns.push({
                    id: '#_group_settings_permissions',
                    name: 'Zugriffsrechte', // i18n.TR('Zugriffsrechte')
                    displayMethod: 'groupSettingsPermissions',
                });
                columns.push({
                    id: '#_group_settings_data',
                    name: 'Daten', // i18n.TR('Daten')
                    displayMethod: 'groupSettingsData',
                });
            } else {
                columns.push({
                    id: '#_group_devices',
                    name: 'Geräte', // i18n.TR('Geräte')
                    displayMethod: 'groupDevices',
                });
            }
            return {
                title: this.showUserGroups ? i18n.TR('Benutzergruppen') : i18n.TR('Gerätegruppen'),
                columns: columns,
                getSortColumn: function (c) {
                    return c.id == '#_name';
                },
                hasRefreshButton: true,
                hasSelectionButtons: true,
                selectionButtons: buttons,
                customButtons: customButtons,
                headingID: this.showUserGroups ? 'user-groups' : 'device-groups',
                displayMethods: {
                    filter: function (value, model) {
                        return AppState.filterToStr(value);
                    },
                    groupLink: function (value, model) {
                        return { type: 'link', text: value, idx: model.id, class: 'js-name' };
                    },
                    groupSettingsData: function (value, model) {
                        var data = {
                            settings: Misc.selectWhere(
                                model.fields,
                                function (itm) {
                                    return AppState.Cache.columnMap[itm];
                                },
                                function (itm) {
                                    return i18n.TR(AppState.Cache.columnMap[itm].name);
                                }
                            ),
                        };
                        return GroupFieldSettingsTemplate(data);
                    },
                    groupSettingsPermissions: function (value, model) {
                        var data = {
                            settings: _.map(_.keys(model.access_rights), function (k) {
                                return { id: k, readOnly: model.access_rights[k], name: Consts.PermissionsLabel[k] };
                            }),
                            is_default: model.is_default,
                        };
                        return GroupPermSettingsTemplate(data);
                    },
                    groupDevices: function (value, model) {
                        return DeviceStatsTemplate(model);
                    },
                    users: function (value, model) {
                        return GroupUsersTemplate(model);
                    },
                },
                footNote: this.showUserGroups
                    ? i18n.TR('Legende') +
                      ': ' +
                      '<i class="fa fa-check text-success"></i> = ' +
                      i18n.TR('Vollzugriff') +
                      ', ' +
                      '<i class="fa fa-eye text-success"></i> = ' +
                      i18n.TR('Nur lesen')
                    : '',
            };
        },

        updateSelectionButtons: function () {
            this.base.updateSelectionButtons();
            this.ui.delete.removeClass('disabled');

            var noDeleteItem = Misc.selectWhereFirst(this.collection.selected, function (item) {
                return item.get('no_delete');
            });

            if (!this.collection.selectedLength || noDeleteItem) {
                this.ui.delete.addClass('disabled');
            }
        },

        add: function () {
            if (this.showUserGroups) this.controller.addUserGroup();
            else this.controller.addGroup();
        },
    },
    'GroupListView'
);
